import React from "react";
import ReactDOM from "react-dom";
import "./app.global.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Elements, StripeProvider } from "react-stripe-elements";
import { BrowserRouter } from "react-router-dom";

// Production/Local Fix: Older modules and external scripts (like react-apexcharts) 
// expect React and ReactDOM to be available globally.
window.React = React;
window.ReactDOM = ReactDOM;
// Fix for Google Maps async callback
window.initMap = window.initMap || function () { console.log("Google Maps initialized"); };

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,

  document.getElementById("root")
);
serviceWorker.unregister();
